import { connect } from 'react-redux';
import { connectModal } from 'redux-modal';
import { compose } from 'redux';
import { hide } from 'js/store/actions/modal';
import SelectSourcesModal from 'js/components/organisms/Modals/SelectSourcesModal';
export default compose(connect(null, function (dispatch, ownProps) {
  return {
    modalClose: function modalClose() {
      dispatch(hide('SelectSourcesModal'));
    }
  };
}), connectModal({
  name: 'SelectSourcesModal',
  destroyOnHide: false
}))(SelectSourcesModal);